export default {
    ADMIN: 'ADMIN'
}
